/* @flow */

const preencherFormularioFuncionamentos = (funcionamentos: string[]) => {
    Array.from(document.querySelectorAll('[name="funcionamentosId[]"]')).forEach((checkbox) => {
        if (!(checkbox instanceof HTMLInputElement)) {
            return;
        }

        if (funcionamentos.length === 0 || funcionamentos.includes(checkbox.value)) {
            checkbox.checked = true;
        }
    });
};

export default preencherFormularioFuncionamentos;
